import { useCallback, useEffect, useState } from 'react';

/**
 * A seconds countdown for buttons that must wait — "Resend code" after a code was sent
 * (one per 60 s), or any action the API answered with 429 and a retryAfter.
 * `start(n)` begins (or extends) the wait; `remaining` is 0 when the button may be used.
 */
export function useCountdown() {
  const [until, setUntil] = useState(0);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (until <= Date.now()) return;
    const t = setInterval(() => setNow(Date.now()), 500);
    return () => clearInterval(t);
  }, [until]);

  const start = useCallback((seconds: number) => {
    const next = Date.now() + Math.max(0, seconds) * 1000;
    setUntil(prev => Math.max(prev, next));
    setNow(Date.now());
  }, []);

  const reset = useCallback(() => setUntil(0), []);

  const remaining = Math.max(0, Math.ceil((until - now) / 1000));
  return { remaining, start, reset };
}
